export default __webpack_public_path__ + "static/media/facebook.3d2ea63c.svg";